import { render, staticRenderFns } from "./SdInputNumber.html?vue&type=template&id=745ae98c&external"
import script from "./SdInputNumber.ts?vue&type=script&lang=ts&external"
export * from "./SdInputNumber.ts?vue&type=script&lang=ts&external"
import style0 from "../SdInput.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports